export default {
  'Kleintierpraxen': [{
    name: 'Tierarztpraxis Anke Meeuws',
    url: 'https://www.tierarzt-karlshorst.info/',
    expertise: ['Röntgen', 'Ultraschall', 'Chirurgie']
  }, {
    name: 'Tierarztpraxis Tempelhof - Dr. Ewert & Wagner',
    url: 'https://www.tierarztpraxis-tempelhof.de/',
    expertise: ['Augenheilkunde', 'Internistik', 'Chirurgie']
  }, {
    name: 'Rosin Tiergesundheit',
    url: 'http://www.tierarzt-rosin.de',
    expertise: ['Schmerztherapie', 'Goldakupunktur']
  }, {
    name: 'Tierarztpraxis Krause',
    url: 'http://www.ta-krause.de/',
    expertise: ['Heimtiere', 'Exoten']
  }, {
    name: 'Dr. med. vet. Regina Korth',
    url: 'http://www.dr-korth.com',
    expertise: ['Equine Dry Needling', 'Thermographie']
  }, {
    name: 'Tierarztpraxis am Amalienpark - Dr. Meike Eimers',
    url: 'https://www.tierarztpraxis-amalienpark.de/',
    expertise: ['Akupunktur', 'Röntgen', 'Labor']
  }],
  'Kleintierkliniken': [{
    name: 'Klinik für kleine Haustiere der Freien Universität Berlin',
    url: 'http://www.vetmed.fu-berlin.de/einrichtungen/kliniken/we20/index.html'
  }, {
    name: 'Tierklinik Berlin-Biesdorf',
    url: 'http://www.tierklinik-in-biesdorf.de'
  }, {
    name: 'Tierklinik Potsdam',
    url: 'http://www.tierklinik-potsdam.de'
  }],
  'Pferdefahrpraxen': [{
    name: 'Tierärztin Lena Bollinger - Pferde und Kleintiere',
    url: 'http://www.tiermedizin-mit-herz.de',
    expertise: ['Zahnbehandlungen Pferd', 'Blasrohrimmobilisation', 'Hausbesuche']
  }],
  'Tierphysiotherapie': [{
    name: 'Tierphysiotherapie & Tiergesundheit - Andrea Vüllings',
    url: 'http://www.tiertherapie-berlin.de/',
    expertise: ['Physiotherapie Hund und Katze']
  }]
};



// WEBPACK FOOTER //
// ./src/modules/partners/fixtures/partners.js